const numberFieldLocalization = {
  increaseLabel: 'Increase',
  decreaseLabel: 'Decrease',
  roleDescription: 'Number field',
}

export default numberFieldLocalization
